const USER_ROLE_IDS = {
    ADMIN: 1,
    USER: 2,
    MANAGER: 3,
};
export { USER_ROLE_IDS };
